import React from 'react';
import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonContent,
  IonGrid,
  IonLabel,
  IonPage,
  IonRow,
  IonTextarea,
  withIonLifeCycle
} from '@ionic/react';
import { RouteComponentProps } from "react-router";
import FirebaseProvider from '../services/FirebaseAnalytics'
import Api from "../services/Api";
import ModalHeader from '../components/ModalHeader';
import { trackEvent } from '../helpers/tracker_actions';

interface ComponentProps extends RouteComponentProps<{}> {
  closeModal?: Function
}

interface ComponentState {
  feedback: string
  done: boolean
  contactMe: boolean
}

class Feedback extends React.Component<ComponentProps, ComponentState> {
  private api = Api.getInstance();
  private firebaseProvider = FirebaseProvider.getInstance()

  state = {
    done: false,
    feedback: '',
    contactMe: false
  }

  ionViewWillEnter() {
    this.setState({
      done: false,
      feedback: '',
      contactMe: false
    })
    this.firebaseProvider.trackView('Feedback')
  }

  private sendFeedback = () => {
    const data = {
      'feedback': this.state.feedback,
      'contact_me': this.state.contactMe
    }
    this.api.post('feedback/save', data).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          this.setState({
            done: true
          });
        }
      })
    });

    trackEvent('Feedback_sent', null)
  }

  goBack = () => {
    if (this.props.closeModal) {
      this.props.closeModal()
    } else {
      this.props.history.goBack()
    }
  }

  handleChange = (event: any) => {
    this.setState({
      feedback: event.target.value
    })
  }

  render() {
    return (
      <IonPage className="cheap_desktop">
        <IonContent>
          <div className="cheap_desktop">
            <div className="mx-4">
              <ModalHeader 
                pageTitle={this.api.tr('feedback')}
                closeModal={() => this.goBack()}/>

              <p className="mt-8">
                {this.api.tr('send_feedback_message')}
              </p>
              {
                this.state.done ? (
                  <p className="mt-8 infoArea p-2">{this.api.tr('feedback_confirmation')}</p>
                ): (
                  <>
                    <IonTextarea 
                      className="textarea_default border_gray mt-8" 
                      rows={5}
                      style={{width: "100%", minWidth: "300px"}}
                      placeholder={this.api.tr('feedback_placeholder')}
                      onIonChange={this.handleChange}
                      name="description"/>

                    <IonGrid className="mt-4">
                      <IonRow>
                        <IonCol>
                          <IonLabel>
                          <p>{this.api.tr('feedback_GDPR')}</p>
                        </IonLabel>
                        </IonCol>
                        <IonCol size="2" class="flex justify-center items-center">
                          <IonCheckbox 
                            checked={this.state.contactMe}
                            onIonChange={e => this.setState({contactMe: !this.state.contactMe})} />
                        </IonCol>
                      </IonRow>
                     </IonGrid>

                    <div className="text_center mt-8">
                      <IonButton 
                        onClick={() => this.sendFeedback()}
                        style={{ width: '100%' }}>{this.api.tr('send')}</IonButton>
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </IonContent>
      </IonPage>
    );
  }
}

export default withIonLifeCycle(Feedback);
